<template>
  <BaseModal :title="$t('Are you sure you want to cancel your appointment?')" @close-modal="emitCloseModal">
    <DoctorComponent
      :doctor="doctor"
      :showServiceTime="true"
      :showCancelAppointmentButton="false"
      :show-payment-method="false"
      :show-doctor-reviews="false"
      :show-map-button="false"
      :show-profile-button="false"
      @close-modal="emitCloseModal"
    />
    <div class="cancel-popup__actions">
      <AppButton
        class="cancel-popup__button cancel-popup__button--confirm"
        :block="true"
        :loading="loading"
        variant="danger"
        @click="emitConfirm"
      >
        <svg class="cancel-popup__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.5" />
          <path d="M12 7v6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" />
          <circle cx="12" cy="16" r="0.8" fill="currentColor" />
        </svg>
        <span class="cancel-popup__label">{{ $t('Yes, cancel') }}</span>
      </AppButton>
      <AppButton
        class="cancel-popup__button cancel-popup__button--return"
        :block="true"
        variant="outline"
        @click="emitCloseModal"
      >
        <svg class="cancel-popup__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M10 7 5 12l5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
          <path d="M5 12h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" />
        </svg>
        <span class="cancel-popup__label">{{ $t('Return') }}</span>
      </AppButton>
    </div>
    <p v-if="errorMessage" class="cancel-popup__error">{{ errorMessage }}</p>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/popup/modal/baseModal.vue';
import DoctorComponent from '@/components/doctor/doctorComponent.vue';
import AppButton from '@/components/buttons/AppButton.vue';

export default {
  name: 'CancelPopup',
  components: {
    DoctorComponent,
    BaseModal,
    AppButton
  },
  props: {
    doctor: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  methods: {
    emitConfirm() {
      if (this.loading) {
        return;
      }
      this.$emit('confirm');
    },
    emitCloseModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.cancel-popup__actions {
  margin-top: 2.4rem;
  display: grid;
  gap: 1rem;
}

@media (min-width: 640px) {
  .cancel-popup__actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.cancel-popup__button {
  min-height: 5rem;
  font-size: 1.5rem;
  letter-spacing: 0.01em;
}

.cancel-popup__button--confirm {
  box-shadow: none;
}

.cancel-popup__button--confirm:not(:disabled):not(.app-button--loading):hover {
  box-shadow: none;
}

.cancel-popup__button--return {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #000000;
}

.cancel-popup__button--return:hover {
  background: #f3f4f6;
  color: #000000;
}

.cancel-popup__icon {
  width: 1.6rem;
  height: 1.6rem;
  stroke: currentColor;
}

.cancel-popup__label {
  display: inline-flex;
  align-items: center;
}

.cancel-popup__error {
  margin-top: 1.6rem;
  color: #b91c1c;
  font-size: 1.3rem;
  text-align: center;
}
</style>
